module.exports = __webpack_public_path__ + "img/apay.3458ff84.png";